import styled from "@emotion/styled";

import { BaseLink } from "shared/components/common/base-link";
import { fontRoboto, fontRobotoCondensed, theme } from "shared/lib/styles";

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  block-size: min-content;
  margin-inline-start: 4.5px;

  ${theme.breakpoints.up("desktop")} {
    margin-inline-start: 0;
  }
`;

export const Timeline = styled(BaseLink)`
  position: relative;

  padding-block-start: 8px;
  padding-inline-start: 24px;

  &:after {
    position: absolute;
    inset-block-start: 0;
    inset-inline-start: 0;
    content: "";

    inline-size: 7px;
    block-size: 7px;
    margin-block-start: 11px;
    margin-inline-start: -4px;

    border-radius: 50%;

    background: #5a5a5a;
  }
`;

export const SnippetTitle = styled.div`
  padding-block-end: 4px;

  color: #000000;
  font-size: 14px;
  font-family: ${fontRoboto};
  line-height: normal;
`;

export const DateContainer = styled.div`
  margin-block-end: 2px;

  color: #5a5a5a;
  font-size: 12px;
  font-family: ${fontRobotoCondensed};
  line-height: normal;
`;
